import router from '../router'

let baseUrl = __API__;
let token = localStorage.getItem("achiev_token");
let currentUserId = localStorage.getItem("user_uid");

export default {
  getResource: function (route, args = null ) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      // let currentPath = router.history.current.fullPath;
      // router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        headers: {
          Authorization: "Bearer " + token
        }
      })
      .then((response) => {
        let x = response.json();

        // Check if the token of the user is not there, if so just clear the localStorage and send them to login
        x.then( (r) => {
          if (r.title === "Token not found" || r.title === "Expired token") {
            localStorage.clear();
            let currentPath = router.history.current.fullPath;
            router.push("/login?next=" + currentPath);
          }
        });


        if(response.status !== 200){

          if (response.status === 401) {
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              localStorage.clear();
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          } else if (response.status === 500) {
            console.log("Oops something went wrong: " + response['title']);
            console.log(JSON.stringify(response))
          }
        }
        return x;
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },
  patchResource: function (route, data, args = null ) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      let currentPath = router.history.current.fullPath;
      router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        body: JSON.stringify(data),
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + token,
          'content-type': 'application/json'
        }
      })
      .then((response) => {
        if(response.status !== 200){
          if(response.status === 401){
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          }
        }
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },
  putResource: function (route, data, args = null ) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      let currentPath = router.history.current.fullPath;
      router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        body: JSON.stringify(data),
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          'content-type': 'application/json'
        }
      })
      .then((response) => {
        if(response.status !== 200){
          if(response.status === 401){
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          }
        }
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },
  postResource: function (route, data, args = null) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      let currentPath = router.history.current.fullPath;
      router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          'content-type': 'application/json'
        }
      })
      .then((response) => {
        if(response.status !== 200){
          if(response.status === 401){
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          }
        }
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },
  delResource: function (route, data, args = null) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      let currentPath = router.history.current.fullPath;
      router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        body: JSON.stringify(data),
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          'content-type': 'application/json'
        }
      })
      .then((response) => {
        if(response.status !== 200){
          if(response.status === 401){
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          }
        }
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },

  postFile: function (route, data, args = null) {
    let token = localStorage.getItem("achiev_token");
    let currentUserId = localStorage.getItem("user_uid");
    let vm = this;

    if(token === null || token === ""){
      let currentPath = router.history.current.fullPath;
      router.push("/login?next=" + currentPath);
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }
    let response = fetch(baseUrl + route,
      {
        body: data,
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          'cache-control': 'no-store',
          'pragma': 'no-cache'
        }
      })
      .then((response) => {
        if(response.status !== 200){
          if(response.status === 401){
            if (localStorage.getItem("user_data") !== null) {
              // vm.$notify({
              //   group: "notification",
              //   title: vm.$t("Error"),
              //   text: vm.$t("You don't have access to this content."),
              //   type: "error"
              // });
              router.push("/dashboard");
            } else {
              let currentPath = router.history.current.fullPath;
              router.push("/login?next=" + currentPath);
            }
          }
        }
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
    return response
  },
  getUserData() {
    return JSON.parse(localStorage.getItem('user_data'));
  },
  setUserData(value) {
    localStorage.setItem('user_data', JSON.stringify(value));
  },

  async uploadFile(route, formThingy, args = null) {
    if(token === null || token === ""){
      router.push("/login");
    }
    if(route.includes("{uid}")){
      route = route.replace("{uid}", currentUserId);
    }
    // Convert the arguments to a query string
    if(args !== null){
      let argsString = "?";
      let keys = Object.keys(args);
      for(let i = 0; i < keys.length; i++){
        argsString += keys[i] + "=" + args[keys[i]];
        if(i < (keys.length - 1)){
          argsString += "&";
        }
      }
      route += argsString
    }

    fetch(baseUrl + route, {
      method: 'POST',
      body: formThingy
    })
      .then(response => response.json())
      .catch(error => console.error('Error:', error))
      .then(response => console.log('Success:', response));
  }
};



// WEBPACK FOOTER //
// ./src/mixins/APIHelper.js